import React from "react";
import styled from "styled-components";
// Components
import FullButton from "../Buttons/FullButton";
// Assets
import DashboardImage from "../../assets/img/dashboard2_426x607.png";
import QuotesIcon from "../../assets/svg/Quotes";
import Dots from "../../assets/svg/Dots";
import { Helmet } from "react-helmet-async";
import HeroPic from "../../assets/img/heropic2.png";
import { Link } from "react-router-dom";



export default function Header() {

  return (
    <>
  <Helmet>
    <meta name="description" content=" Our software empowers chamas and investment groups to manage members, finances, ChamaFlow is a powerful desktop app built for African Chamas, SACCOS, and informal savings groups."/>
     <link rel='canonical' href='/'/>


  </Helmet>
<Wrapper id="home" className="container flexSpaceCenter">
      <LeftSide className="flexCenter">
        <div>
   
<h3 className="extraBold font60">
  Empower Your Group with <span style={{ color: 'purple' }}>ChamaFlow</span> - All in One Solution
</h3>
         <HeaderP className="font18 semiBold">
          ChamaFlow is a powerful desktop app built for African Chamas, SACCOS, and informal savings groups. 
          Manage contributions, loans, and reports — all in one secure, user-friendly platform. Go beyond spreadsheets and unlock financial clarity and growth.
        </HeaderP>
         {/* Call-to-action buttons */}
        <CTAWrapper>
          {/*<BtnWrapper>
            <a href="https://chamaflow.roshtech.co.ke/request-trial" target="_self" rel="noopener noreferrer">
              <FullButton title="Start Free" />
            </a>
          </BtnWrapper>*/}
          <BtnWrapperSecondary>
            <Link to="/request-demo" rel="noopener noreferrer">
              <FullButton title="Request Demo" style={{ backgroundColor: '#fff', color: 'purple', border: '2px solid purple' }} />
            </Link>
          </BtnWrapperSecondary>
        </CTAWrapper>

        </div>
      </LeftSide>
      <RightSide>
        <ImageWrapper>
          <Img className="radius8" src={HeroPic} alt="office" style={{zIndex: 9,width:'600px',height:'607px'}} />
          <QuoteWrapper className="flexCenter darkBg radius8">
            <QuotesWrapper>
              <QuotesIcon />
            </QuotesWrapper>
            <div>
         
  <p className="font15 whiteColor">
    <em>
      ChamaFlow has simplified how we manage group savings, loans, and records. Our members can now track their balances and contributions easily — no more spreadsheets or confusion during payouts!
    </em>
  </p>
  <p className="font13 orangeColor textRight" style={{ marginTop: '10px' }}>Mercy Wanjiku, Treasurer – Umoja Women Group</p>
</div>
          </QuoteWrapper>
          <DotsWrapper>
            <Dots />
          </DotsWrapper>
        </ImageWrapper>
        <GreyDiv className="lightBg"></GreyDiv>
      </RightSide>
    </Wrapper>
    
    </>
  );
}


const Wrapper = styled.section`
  padding-top: 80px;
  width: 100%;
  min-height: 840px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
const LeftSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 2;
    margin: 50px 0;
    text-align: center;
  }
  @media (max-width: 560px) {
    margin: 80px 0 50px 0;
  }
`;
const RightSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 1;
    margin-top: 30px;
  }
`;
const HeaderP = styled.div`
  max-width: 470px;
  padding: 15px 0 50px 0;
  line-height: 1.5rem;
  @media (max-width: 960px) {
    padding: 15px 0 50px 0;
    text-align: center;
    max-width: 100%;
  }
`;
const BtnWrapper = styled.div`
  max-width: 190px;
  @media (max-width: 960px) {
    margin: 0 auto;
  }
`;
const GreyDiv = styled.div`
  width: 30%;
  height: 700px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
  @media (max-width: 960px) {
    display: none;
  }
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 9;
  @media (max-width: 960px) {
    width: 100%;
    justify-content: center;
  }
`;
const Img = styled.img`
  @media (max-width: 560px) {
    width: 80%;
    height: auto;
  }
`;
const QuoteWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 50px;
  max-width: 330px;
  padding: 30px;
  z-index: 99;
  @media (max-width: 960px) {
    left: 20px;
  }
  @media (max-width: 560px) {
    bottom: -50px;
  }
`;
const QuotesWrapper = styled.div`
  position: absolute;
  left: -20px;
  top: -10px;
`;
const DotsWrapper = styled.div`
  position: absolute;
  right: -100px;
  bottom: 100px;
  z-index: 2;
  @media (max-width: 960px) {
    right: 100px;
  }
  @media (max-width: 560px) {
    display: none;
  }
`;
const CTAWrapper = styled.div`
  display: flex;
  gap: 20px;
  max-width: 100%;
  flex-wrap: wrap;
  @media (max-width: 560px) {
    flex-direction: column;
    align-items: center;
  }
`;

const BtnWrapperSecondary = styled.div`
  max-width: 190px;
`;


